import { createFileRoute, redirect } from "@tanstack/react-router";

// Port of portal's `_index.tsx`: the bare locale root (e.g. `/nl`) always forwards to login.
// For an authenticated user the login route's already-logged-in bounce (`loginCallback`) then
// forwards to their school — this is also how impersonation lands on the impersonated user's
// school after its redirect to `/{locale}`.
export const Route = createFileRoute("/$locale/{-$schoolyear}/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/login",
      params: { locale: params.locale, schoolyear: params.schoolyear },
    });
  },
});
